export const FetchDesignSelectSelectors = {
  block: "FetchDesignSelect",
  error: "FetchDesignSelect__error",
  menuList: "FetchDesignSelect__menu-list",
  valueContainer: ".FetchDesignSelect__value-container", // this is a class selector for reaching into react-select
};
